export function copyToClipboard(text: string, format = 'text/plain') {
    document.addEventListener('copy', (e: ClipboardEvent) => {
        e.clipboardData.setData(format, (text));
        e.preventDefault();
        document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
}
